__turbopack_context__.v({
  "donateButton": "Donate-module__XghOJG__donateButton",
  "icon": "Donate-module__XghOJG__icon",
});
